/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";

import { useParams } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";
import { assetImages } from "constants";

import { formatStringDate } from "helpers/DateCalculation";

//import option for availibility
import availibilityOptions from "data/Prod/CalendarAvailability.json";
import Shifts from "data/Prod/Shifts.json";

//import context
import { GlobalProvider } from "context/GlobalContext";

const ShowAgendaDetails = ({
  selectedDate,
  selectedShift,
  selectedStarttime,
  onCloseModal,
  filterAgendaIncludeClientId,
  filterAgendaExcludeClientId,
}) => {
  const { filterAgendaEducatorTags } = useContext(GlobalProvider);

  const token = localStorage.getItem("token"); // token

  /* ========== get user id from url params ========= */
  const params = useParams();

  const { t } = useTranslation(); //for translation

  const [availableEducators, setAvailableEducators] = useState([]);
  const [assignedEducators, setAssignedEducators] = useState([]);
  const [reserveEvents, setReserveEvents] = useState([]);
  const [responseDate, setResponseDate] = useState("");
  const [responseShift, setResponseShift] = useState("");
  const [requiredEducator, setRequiredEducator] = useState("");
  const [consecutiveEventsCount, setConsecutiveEventsCount] = useState(0);
  const [requiredEducatorConsecutive, setRequiredEducatorConsecutive] = useState(0);
  const [requiredEducatorNonConsecutive, setRequiredEducatorNonConsecutive] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const today = new Date().toISOString().split("T")[0];

  //function for get current time and set by defualt
  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const timenow = `${hours}:${minutes}`;

    return timenow;
  };

  // get all the educators available in the date and shift
  const getAgendaEducators = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_EDUCATORS_BY_EVENT_AGENDA +
        `?token=${token}` +
        `&date=${selectedDate}` +
        `&shift=${selectedShift}` +
        `&starttime=${selectedStarttime}`;

      if (filterAgendaEducatorTags.length > 0) {
        requestUrl += `&eductortags=${filterAgendaEducatorTags}`;
      }

      if (filterAgendaIncludeClientId) {
        requestUrl += `&filterincludeclient=${filterAgendaIncludeClientId}`;
      }

      if (filterAgendaExcludeClientId) {
        requestUrl += `&filterexcludeclient=${filterAgendaExcludeClientId}`;
      }

      console.log("API_GET_EDUCATORS_BY_EVENT_AGENDA", requestUrl);

      const response = await getData(requestUrl);

      console.log("Response in agenda body------->", response);

      if (response.status) {
        setAvailableEducators(response.availableEducators);

        setAssignedEducators(response.reservedEducators); // assigned educators,

        setResponseDate(response.date);

        setResponseShift(response.shift);

        setReserveEvents(response.reserveEvents);

        setRequiredEducator(response.requiredEducator);
        setConsecutiveEventsCount(response.consecutiveEventsCount || 0);
        setRequiredEducatorConsecutive(response.requiredEducatorConsecutive || 0);
        setRequiredEducatorNonConsecutive(response.requiredEducatorNonConsecutive || 0);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const closeModalHandler = () => {
    resetHandler();
    onCloseModal();
  };

  const resetHandler = () => {
    setAvailableEducators([]);
    setAssignedEducators([]);
    setReserveEvents([]);
    setResponseDate("");
    setResponseShift("");
    setRequiredEducator("");
    setConsecutiveEventsCount(0);
    setRequiredEducatorConsecutive(0);
    setRequiredEducatorNonConsecutive(0);
  };

  //use effect for getAgendaEducators
  useEffect(() => {
    resetHandler();

    if (selectedDate && selectedStarttime) {
      getAgendaEducators();
    }
  }, [selectedDate, selectedStarttime]);

  // initialize Bootstrap tooltips with container:body so they render above the modal
  useEffect(() => {
    const tooltipEls = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const instances = Array.from(tooltipEls).map(
      (el) => new window.bootstrap.Tooltip(el, { container: "body" })
    );
    return () => instances.forEach((t) => t.dispose());
  }, [isLoading]);

  return (
    <div
      className="modal fade"
      id="agendaDetailInfo"
      tabIndex="-1"
      aria-labelledby="submitSurveyLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content border-0 rounded-0">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close p-2 bg-white shadow-none shadow-sm m-0 ms-auto"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModalHandler}
            ></button>
          </div>
          <div className="modal-body p-5 pt-0">
            <h3 className="text-center ">{t("Agenda Information")}</h3>
            <hr />
            {isLoading ? (
              <div className="placeholder-glow">
                <p>
                  <span className="placeholder col-3 me-4"></span>
                  <span className="placeholder col-2"></span>
                </p>
                <hr />
                <p>
                  <span className="placeholder col-2 me-4"></span>
                  <span className="placeholder col-2 me-4"></span>
                  <span className="placeholder col-2"></span>
                </p>
                <hr />
                {[1, 2, 3].map((i) => (
                  <div key={i}>
                    <p><span className="placeholder col-4"></span></p>
                    <p><span className="placeholder col-6"></span></p>
                    <p><span className="placeholder col-5"></span></p>
                    <hr />
                  </div>
                ))}
                <p>
                  <span className="placeholder col-3"></span>
                </p>
              </div>
            ) : (
              <>
            <p>
              <b>
                {t("Date")} :{" "}
                <span className="text-primary">
                  {" "}
                  {responseDate ? formatStringDate(responseDate) : ""}{" "}
                </span>{" "}
              </b>
              <b className="ms-5">
                {t("Shift")} :{" "}
                <span className="text-primary"> {responseShift} </span>{" "}
              </b>
            </p>

            <hr />
            <div className="d-flex flex-wrap gap-3 mb-3">

              {/* Educators Required */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#fff3f3", border: "1px solid #f5c6c6" }}
              >
                <span className="material-icons-outlined text-danger" style={{ fontSize: "20px" }}>group</span>
                <span className="small text-muted">{t("Educators Required")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Sum of all educators required for each activity. Each activity can specify how many educators are needed for its completion.")}
                >
                  info
                </span>
                <span className="fw-bold text-danger ms-1">{requiredEducator}</span>
              </div>

              {/* Educators Req. for Consecutive Events */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#fff8f0", border: "1px solid #ffd8a8" }}
              >
                <span className="material-icons-outlined text-warning" style={{ fontSize: "20px" }}>repeat</span>
                <span className="small text-muted">{t("Educators Req. for Consecutive Events")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Total educators needed across all consecutive reserve groups. Consecutive reserves share a single educator allocation counted only once per group.")}
                >
                  info
                </span>
                <span className="fw-bold text-warning ms-1">{requiredEducatorConsecutive}</span>
              </div>

              {/* Educators Req. for Non-Consecutive Events */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#f0f7ff", border: "1px solid #b6d4fe" }}
              >
                <span className="material-icons-outlined text-primary" style={{ fontSize: "20px" }}>person_outline</span>
                <span className="small text-muted">{t("Educators Req. for Non-Consecutive Events")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Total educators needed for standard (non-consecutive) reservations in this shift.")}
                >
                  info
                </span>
                <span className="fw-bold text-primary ms-1">{requiredEducatorNonConsecutive}</span>
              </div>

              {/* Educators Assigned */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#f0fff4", border: "1px solid #b2dfdb" }}
              >
                <span className="material-icons-outlined text-success" style={{ fontSize: "20px" }}>how_to_reg</span>
                <span className="small text-muted">{t("Educators Assigned")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Number of educators who have already been assigned to reservations in this shift.")}
                >
                  info
                </span>
                <span className="fw-bold text-success ms-1">{assignedEducators.length}</span>
              </div>

              {/* Reserve Events */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#f5f0ff", border: "1px solid #d0b4fe" }}
              >
                <span className="material-icons-outlined" style={{ fontSize: "20px", color: "#7c3aed" }}>event_note</span>
                <span className="small text-muted">{t("Reserve Events")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Total number of reservations scheduled for this day in this shift.")}
                >
                  info
                </span>
                <span className="fw-bold ms-1" style={{ color: "#7c3aed" }}>{reserveEvents.length}</span>
              </div>

              {/* Consecutive Events */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#fff8f0", border: "1px solid #ffd8a8" }}
              >
                <span className="material-icons-outlined text-warning" style={{ fontSize: "20px" }}>repeat</span>
                <span className="small text-muted">{t("Consecutive Events")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Number of unique consecutive reserve groups in this shift. A consecutive group means the same activity runs back-to-back across multiple time slots.")}
                >
                  info
                </span>
                <span className="fw-bold text-warning ms-1">{consecutiveEventsCount}</span>
              </div>

              {/* Non-Consecutive Events */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#f0f7ff", border: "1px solid #b6d4fe" }}
              >
                <span className="material-icons-outlined text-primary" style={{ fontSize: "20px" }}>event_available</span>
                <span className="small text-muted">{t("Non-Consecutive Events")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Number of standard reservations that are not part of any consecutive group.")}
                >
                  info
                </span>
                <span className="fw-bold text-primary ms-1">{reserveEvents.filter(r => !r.isconsecutivereserve).length}</span>
              </div>

              {/* Total Educators */}
              <div
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
                style={{ background: "#f0fff4", border: "1px solid #6dd5a8" }}
              >
                <span className="material-icons-outlined text-success" style={{ fontSize: "20px" }}>groups</span>
                <span className="small text-muted">{t("Total Educators")}</span>
                <span
                  className="material-icons-outlined text-secondary ms-1"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={t("Total count of all educators assigned across every reservation in this shift. An educator appearing in multiple reservations is counted each time.")}
                >
                  info
                </span>
                <span className="fw-bold text-success ms-1">
                  {reserveEvents.reduce((sum, r) => sum + (r.educators ? r.educators.length : 0), 0)}
                </span>
              </div>

            </div>
            {reserveEvents.length > 0 &&
              reserveEvents.map((reserve, index) => {
                return (
                  <div key={index}>
                    <hr />
                    <p className="text-primary">
                      {reserve.isconsecutivereserve ? (
                        <span className=" badge bg-danger me-2 fw-bold">
                          {" "}
                          C{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      <span className="fw-bold me-2">
                        {" "}
                        {reserve.starttime} - {reserve.endtime}{" "}
                      </span>{" "}
                      {reserve.ambreservationid? 'AMB' : 'CUS'} ID :
                      ({reserve.ambreservationid? reserve.ambreservationid : reserve.customerid})
                    </p>
                    <p className="d-flex align-items-center text-nowrap">
                      <span>
                        {" "}
                        <b className="me-2">
                          {t("School")} / {t("Beneficiary")} :
                        </b>
                        {reserve.beneficiaries[0]
                          ? reserve.beneficiaries[0].name +
                            "" +
                            (reserve.beneficiaries[0].surname
                              ? reserve.beneficiaries[0].surname
                              : "")
                          : ""}
                      </span>
                    </p>
                    <p className="d-flex align-items-center text-nowrap ms-2">
                      <span className="material-icons-outlined">
                        subdirectory_arrow_right
                      </span>
                      <b className="me-2"> {t("Educators")} :</b>
                      {reserve.educators.length > 0 &&
                        reserve.educators.map((educator, indes) => {
                          return (
                            <>
                              <span className="d-block icon-user me-2">
                                <img
                                  src={
                                    educator.photoimage
                                      ? educator.photoimage.path
                                      : assetImages.defaultUser
                                  }
                                  alt=""
                                />
                              </span>

                              <span className="d-block text-primary">
                                {educator.name} {educator.surname}
                              </span>
                            </>
                          );
                        })}
                    </p>
                    <p className="d-flex  align-items-center text-nowrap ms-4">
                      <span className="material-icons-outlined">
                        subdirectory_arrow_right
                      </span>
                      <b className="me-2"> {t("Activity")} :</b>
                      <span>
                        {reserve.activitycode
                          ? (reserve.activitycode.code != "NULL"
                              ? reserve.activitycode.code
                              : "___-_") +
                            " : " +
                            reserve.activitycode.name
                          : ""}
                        {reserve.activitycode && reserve.activitycode.educatorcount && (
                          <span className="ms-2 text-secondary">
                            ({t("Required Educator")} : {reserve.activitycode.educatorcount})
                          </span> 
                        )}
                      </span>
                    </p>
                  </div>
                );
              })}
            <hr />
            <p>
              <b>
                {t("Educators Available")} :{" "}
                <span className="text-success">
                  {availableEducators.length}
                </span>{" "}
              </b>
            </p>

            {availableEducators.length > 0 &&
              availableEducators.map((educator, index) => {
                return (
                  <p
                    className="d-flex gap-2 align-items-center text-nowrap"
                    key={index}
                  >
                    <span className="d-block icon-user">
                      <img
                        src={
                          educator.photoimage
                            ? educator.photoimage.path
                            : assetImages.defaultUser
                        }
                        alt=""
                      />
                    </span>
                    <span className="d-block text-success">
                      {educator.name} {educator.surname}
                    </span>
                  </p>
                );
              })}
            </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowAgendaDetails;
